import * as serviceReports from './list'

import { ServiceReport } from 'app/types/reports/service'

export const allServiceReports: ServiceReport[] = Object.values(
    serviceReports,
).sort((previous, current) =>
    current.creation_date.localeCompare(previous.creation_date),
)
